import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

const WhoWeAre = () => {
  return (
    <div className="section section-about-us">
      <Container>
        <Row>
          <Col className="ml-auto mr-auto text-center" md="8">
            <h2 className="title">Who we are?</h2>
            <h5 className="description">
              Born in 2016, All My Sports SA is company that provides admin and
              sourcing support to all codes of sport. We offer assistance on all
              aspects that clubs and federations need assistance with in order
              to advance the sporting code, from sourcing the equipment,
              advancing athlete management training to sport event marketing and
              execution. <br />
              <br />
              MISSION: To provide a complete solution to assist administrators
              and athletes in sport with all the support they need. We pride
              ourselves to be the link to the sporting world.
            </h5>
          </Col>
        </Row>
        <div className="separator separator-info"></div>
        <div className="section-story-overview">
          <Row>
            <Col md="6">
              <div
                className="image-container image-left"
                style={{
                  backgroundImage:
                    "url(" +
                    require("../../assets/img/login.jpg").default +
                    ")",
                }}
              ></div>
              <div
                className="image-container"
                style={{
                  backgroundImage:
                    "url(" +
                    require("../../assets/img/106226027_3673820899298012_4165228408522325438_n.jpg")
                      .default +
                    ")",
                }}
              ></div>
            </Col>
            <Col md="5">
              <div
                className="image-container image-right"
                style={{
                  backgroundImage:
                    "url(" +
                    require("../../assets/img/120221526_10158844265006369_6785176384684935922_n.jpg")
                      .default +
                    ")",
                }}
              ></div>
              <h3>UNUSED SPORTS GOODS</h3>
              <p>
                Due to the lack of sport in schools, our youth are faced with
                lots of free time which leads to them being involved in the
                social ills that destroys the fabric of our society. We want to
                give the youth hope and better future by introducing them to
                sport. Due to the lack of equipment, clubs / NGO’s and schools
                battle to implement this. There are many households that have
                used sports good like balls, racquets, shoes and clothing in
                fair condition that we can use to start the journey of sport in
                their lives. Help us grow the culture of sport, discipline and
                ubuntu. We have partnered with Wholesun Bread who produce our
                collection boxes. Please contact us if you would like a box of
                your club or office or can act as a collection point for your
                family and friends. We will gladly collect it and repurpose it.
                Thank you for being part of the change and shaping South Africa.
                <br />
                <br />
                #makeithappen #bethechange #supportforsports
              </p>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default WhoWeAre;
